import { render, staticRenderFns } from "./UserBind1.vue?vue&type=template&id=0b346a7e&"
import script from "./UserBind1.vue?vue&type=script&lang=js&"
export * from "./UserBind1.vue?vue&type=script&lang=js&"
import style0 from "./UserBind1.vue?vue&type=style&index=0&lang=less&socped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports